import React,{useState} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import { RootState } from "../../store/rootReducer";
import {
    Grid,
    Button, IconButton,
    TextField,
    Dialog, DialogTitle, DialogContent,
    CircularProgress,
} from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { useStyles } from "./styles";

import CloseIconSvg from "../../assets/icons/team_members/close.svg";
import { getRoles } from '../auth/loginHelpers';

const Popup: React.FC<any> = ({ popState, setPopState, setMember,users,initialRender }): JSX.Element => {
    const classes = useStyles();
    
    const [usersLoading, setUsersLoading] = React.useState<boolean>(false);
    const { appState, authStore } = useSelector((state: RootState) => state);
    const [isSMAUser, setIsSMAUser] = useState((authStore.data?.IsSMAUser != null) ? authStore.data?.IsSMAUser : true);
    //const [users, setUsers] = React.useState<any>([]);
    const [userSelected, setUserSelected] = React.useState<any>(null);
    const [userInput, setUserInput] = React.useState<any>("");
    
    React.useEffect(() => { 
        getUsersList();
        initialRender = false
    }, [])
    
    const getUsersList = async () => {             
        // setUsers([
        //     { id: 10, name: "Duncan Matthews" },
        //     { id: 20, name: "Adam Michael" },
        //     { id: 30, name: "Mary Sargent" },
        //     { id: 40, name: "Jerome Taylor" },
        //     { id: 50, name: "King James" },
        // ]);
    }
    
    return (
        <>
            {popState && (<>
            <Dialog
                open={popState}
                onClose={() => setPopState(false)}
                className={classes.dialog}
                fullScreen={true}
            >
                <DialogTitle disableTypography>
                    Add Team Member
                    <IconButton className={"closeButton"} onClick={() => setPopState(false)}>
                        <img src={CloseIconSvg} alt="" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container>
                        <Grid item xs={12} sm={12}>
                            <Autocomplete
                                id="user-autocomplete"
                                fullWidth
                                options={users}
                                //loading={usersLoading}
                                noOptionsText="No user found"
                                getOptionLabel={(option: any) => option.name}
                                //getOptionSelected={(option: any, value: any) => option.id === value.id}
                                value={userSelected}
                                onChange={(event: any, newValue: any) => {
                                    //console.log(newValue);
                                    setUserSelected(newValue);
                                    setMember(newValue);                                                                                                   
                                }}
                                inputValue={userInput}
                                onInputChange={(event: any, newInputValue: any) => {
                                    //console.log(newValue);
                                    setUserInput(newInputValue);                                                               
                                    //getUsersList();
                                }}
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant='outlined'
                                        InputProps={{
                                            ...params.InputProps,
                                            classes: { root: classes.textFieldInput },
                                            endAdornment: (
                                                <React.Fragment>
                                                    {/* {usersLoading ? <CircularProgress color="inherit" size="20px" /> : null} */}
                                                </React.Fragment>
                                            ),
                                        }}
                                        placeholder="Search"
                                    />
                                )}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
            </>)}
        </>
    );
}

export default React.memo(withRouter(Popup));